/**
 * Split the input string on lines (`\n`) and return an array of trimmed lines
 * @param input - The input string to split
 * @returns An array of trimmed lines
 */
export function splitOnLinesOf(input: string): string[] {
  return input
    .split("\n")
    .map((acc) => acc.trim())
    .filter(Boolean);
}
